import { HomePage } from "./../home/home";
import { TranslateService } from "@ngx-translate/core";
import { Storage } from "@ionic/storage";
import { ServiceProvider } from "./../../providers/service/service";
import { Http, RequestOptions, Headers } from "@angular/http";
import { ViewHeaderPage } from "./../view-header/view-header";
import { Component } from "@angular/core";
import { IonicPage, NavController, LoadingController } from "ionic-angular";

@IonicPage()
@Component({
  selector: "page-plaza-overview-plazamap",
  templateUrl: "plaza-overview-plazamap.html",
})
export class PlazaOverviewPlazamapPage {
  spaces: any = [1];
  themes: any;
  theme = 1;

  constructor(
    public navCtrl: NavController,
    private storage: Storage,
    private services: ServiceProvider,
    private http: Http,
    private translateService: TranslateService,
    private loadingCtrl: LoadingController
  ) {}

  async ionViewDidLoad() {
    this.theme = await this.storage.get("theme");

    const loader = this.loadingCtrl.create({
      content: "Loading...",
    });
    loader.present();

    this.storage.get("token").then(async (token) => {
      var link = this.services.URLSpaces;
      var headers = new Headers();
      headers.append("Accept", "application/json");
      headers.append("Authorization", "Bearer " + token);
      const requestOptions = new RequestOptions({ headers: headers });

      this.http
        .get(link, requestOptions)
        .map((res) => res.json())
        .subscribe(
          (data) => {
            // this.spaces = data.filter(
            //   (x) => x.shop != null || x.socialShop != null
            // );
            this.spaces = data;
            loader.dismiss();
          },
          (error) => {
            var response = JSON.parse(error._body);

            this.translateService.get(response.message).subscribe((value) => {
              this.services.presentToast(value);
            });
            loader.dismiss();
          }
        );

      var link2 = this.services.URLGetTheme;

      this.http
        .get(link2, requestOptions)
        .map((res) => res.json())
        .subscribe(
          (data) => {
            this.themes = data;
          },
          (error) => {
            var response = JSON.parse(error._body);

            this.translateService.get(response.message).subscribe((value) => {
              this.services.presentToast(value);
            });
          }
        );
    });
  }

  doRefresh(refresher) {
    this.storage.get("token").then((token) => {
      var link = this.services.URLSpaces;
      var headers = new Headers();
      headers.append("Accept", "application/json");
      headers.append("Authorization", "Bearer " + token);
      const requestOptions = new RequestOptions({ headers: headers });

      this.http
        .get(link, requestOptions)
        .map((res) => res.json())
        .subscribe(
          (data) => {
            this.spaces = data;
          },
          (error) => {
            var response = JSON.parse(error._body);

            this.translateService.get(response.message).subscribe((value) => {
              this.services.presentToast(value);
            });
          }
        );

      var link2 = this.services.URLGetTheme;

      this.http
        .get(link2, requestOptions)
        .map((res) => res.json())
        .subscribe(
          (data) => {
            this.themes = data;
          },
          (error) => {
            var response = JSON.parse(error._body);

            this.translateService.get(response.message).subscribe((value) => {
              this.services.presentToast(value);
            });
          }
        );
    });

    refresher.complete();
  }

  backPage() {
    this.navCtrl.pop();
  }

  homePage() {
    this.navCtrl.setRoot(HomePage);
  }

  openHeadPage() {
    this.navCtrl.push(ViewHeaderPage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/plaza-overview-plazamap/plaza-overview-plazamap.ts